import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Button } from '@getgrover/ui';

import ggOrder, { OrderComponentSummary } from 'ggApp/modules/order';
import ggStore from 'ggApp/modules/store';
import ggAddress, { AddressComponent_List as AddressList } from 'ggApp/modules/address';
import {
    LayoutComponent_Grid_Col as Col,
    LayoutComponent_Grid_Row as Row,
    LayoutComponent_Container as Container,
    LayoutComponent_Checkout_Title as CheckoutTitle,
    LayoutComponent_Checkout_ContentWrap as ContentWrap,
    LayoutComponent_Checkout_Add as CheckoutAdd,
    LayoutComponent_Text as Text,
} from 'ggApp/modules/layout';
import ggAuth from 'ggApp/modules/auth';
import { RouterComponent_LinkWithStore as Link } from 'ggApp/modules/router';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { CheckoutBackToCartLink } from 'ggApp/modules/checkout/components';

import ProfileFormConfirmPhone from 'ggApp/shared/forms/profile/confirmPhone';

const { SHIPPING_NAME } = ggAddress.constants;

@connect(
    createStructuredSelector({
        authPhoneVerification: ggAuth.selectors.phoneVerification,
        authFetching: ggAuth.selectors.fetching,
        phonePrefixes: ggStore.selectors.phonePrefixes,
        user: ggAuth.selectors.user,
        order: ggOrder.selectors.orderActive,
        addressActiveShippingId: ggAddress.selectors.activeAddressShippingId,
        addressList: ggAddress.selectors.addressListForCurrentCountry,
    }),
    (dispatch) => ({
        authActions: bindActionCreators(ggAuth.actions, dispatch),
        orderActions: bindActionCreators(ggOrder.actions, dispatch),
    }),
)
export default class CheckoutAddress extends Component {
    render() {
        const { orderActions, authActions } = this.props;
        const {
            addressList,
            addressActiveShippingId,
            order,
            user,
            authPhoneVerification,
            authFetching,
            phonePrefixes,
        } = this.props;
        const modalAddressSuccessUrl = encodeURIComponent('/checkout/address');
        const userNumberPrefix = ggAuth.helpers.detectUserNumberPrefix(user, phonePrefixes);

        return (
            <section>
                <CheckoutTitle tk="CART_ADDRESS_SHIPPING_TITLE" />
                <Container>
                    <Text mini lightWeight>
                        <Translator tk="CART_ADDRESS_SHIPPING_NOTE" />
                    </Text>
                    <ContentWrap as ContentWrap>
                        <Row cols={[1, 1]}>
                            <Col desktop={40}>
                                <OrderComponentSummary hideMobile desktopColumnItem order={order} />
                                <CheckoutBackToCartLink />
                            </Col>
                            <Col desktop={60}>
                                <AddressList
                                    addressType={SHIPPING_NAME.toLowerCase()}
                                    noMarginBottom
                                    onClick={(addressId) => {
                                        orderActions.updateOrder({
                                            shipping_address_id: addressId,
                                        });
                                        orderActions.updateOrderAddress(
                                            order.number,
                                            addressId,
                                            SHIPPING_NAME,
                                        );
                                    }}
                                    activeId={addressActiveShippingId}
                                    list={addressList}
                                />
                                <CheckoutAdd
                                    text="DONT_HAVE_ADDRESS"
                                    linkText="ADD_NEW_ADDRESS"
                                    to={`/checkout/address?modal=address-create&modal-address-type=shipping&modal-address-success-url=${modalAddressSuccessUrl}`}
                                />

                                <ProfileFormConfirmPhone
                                    authPhoneVerification={authPhoneVerification}
                                    authFetching={authFetching}
                                    updatePhone={authActions.updatePhone}
                                    confirmPhone={authActions.confirmPhone}
                                    initialValues={{
                                        phone: {
                                            code: userNumberPrefix.prefix || phonePrefixes[0].id,
                                            number: userNumberPrefix.number,
                                            isVerified: user.phone_verified,
                                        },
                                    }}
                                    onSubmit={() => {}}
                                />

                                <Link
                                    to="/checkout/payment"
                                    onClick={(e) => {
                                        if (!addressActiveShippingId || !user.phone_verified) {
                                            e.preventDefault();
                                        }
                                    }}
                                >
                                    <Button
                                        primary
                                        fullWidth
                                        centred
                                        disabled={!addressActiveShippingId || !user.phone_verified}
                                    >
                                        <Translator tk="CONTINUE" />
                                    </Button>
                                </Link>
                            </Col>
                        </Row>
                    </ContentWrap>
                </Container>
            </section>
        );
    }
}
